
const Employee = {
    store(data) {
        return axios.post(window.storeEmployee, data);
    }
};

export { Employee };


// WEBPACK FOOTER //
// ./resources/assets/js/services/Employee.js